<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-11">
          <strong class="card-title mb-2" v-if="!isFromDashBoard">{{ 'All Cron Analysis' }}</strong>
          <h4 class="card-title m-0 float-left" v-if="isFromDashBoard">{{ 'All Cron Analysis' }}</h4>
        </div>
        <!-- <div class="col-md-1" v-if="!isFromDashBoard">
          <download :tableId="'cron-time'" :fileName="'cron-time'"></download>
        </div> -->
        <div class="col-md-1" v-if="!isFromDashBoard">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker :input-class="'form-control'" :format="'dd-MM-yyyy'" v-model="ddate"
              @selected="getSelDate($event)"></datepicker>
          </div>
        </div>
      </div>
      <form v-if="fillableData.length > 0" class="form-horizontal form-cs" @onsubmit.prevent action>
        <div>
          <table class="table table-bordered fonts11 app-inner">
            <tr v-for="(tab, index) in fillableData[0].corn_name_list" v-bind:key="'tab' + index">
              <th style="background-color: white;"><a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.corn_name
                    }}</b></a>
                <div class="pt-2" v-if="tab.show">
                  <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                    <div>
                      <table style="width:100%;background-color:white;">
                        <thead>
                          <th>Sr.</th>
                          <th v-for="field in tableFields" v-bind:key="'field' + field.title">{{ field.title }}</th>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in tab.function_list" v-bind:key="'row' + index">
                            <td>{{ index + 1 }}</td>
                            <td v-for="field in tableFields" v-bind:key="field.name + index">
                              <span v-if="field.type === 'date'">{{ getDateTime(row[field.name]) }}</span>
                              <span v-else-if="field.type === 'number'">{{ getFixed(row[field.name]) }}</span>
                              <span v-else>{{ row[field.name] }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </th>
            </tr>
          </table>
        </div>
      </form>
      <span v-else>No Data Found...!</span>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Datepicker },
  mixins: [commonMixins],
  name: "allCronAnalysis",
  props: ["isFromDashBoard"],
  created() {
    this.url = this.apiUrl;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = 1);
    // this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData();
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "cronTimeTakenAnalysisdailyloginsertGlobalCron",
      pageType: "timeTakenAnalysisCron",
      ddate: new Date(), //.setDate(new Date().getDate() - 1),
      perPage: 100,
      company: {},
      actions: [],
      tableFields: [
        {
          name: "function_name",
          title: "Function Name",
          type: 'string'
        },
        {
          name: "start_time",
          title: "Start Time",
          type: 'string'
        },
        {
          name: "end_time",
          title: "End Time",
          type: 'date'
        },
        {
          name: "duration",
          title: "Duration",
          type: 'time'
        },
        {
          name: "days",
          title: "Days",
          type: 'string'
        }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  },
  methods: {
    showDetails(tabs) {
      console.log('tabs', tabs)
      tabs.show = !tabs.show;
    },
    fetchData() {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = {
          date: myself.getDate(myself.ddate),
          pageid: myself.pageToLoad
        };
        http.post(this.url, params, function (error, response) {
          console.log(response);
          let resData = response.final_data;

          if (resData.length > 0) {
            resData[0].corn_name_list.forEach((function (item, idx) {
              resData[0].corn_name_list[idx].show = false;
            }));
            myself.fillableData = resData;
          } else {
            myself.fillableData = resData;
          }
          myself.isLoading = false;

        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      this.fetchData();
    }
    /* prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      // if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData();
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    */
  }
};
</script>
<style scoped>
.table td {
  padding: 5px 10px 5px 10px;
}

.form-cs {
  border: 1px solid #c4c2c2;
  padding: 13px;
  padding-bottom: 0;
  border-radius: 7px;
  background-color: #f5faff;
}

.form-cs-n {
  border: 1px solid #c4c2c2;
  padding: 5px;
  border-radius: 7px;
  background-color: #f5faff;
}
</style>



// WEBPACK FOOTER //
// src/views/activity-logs/all-cron-analysis.vue